import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { Box, Paper, Typography } from "@mui/material";
import type { UserRole } from "../auth/auth";
import LoyaltyPointsHistoryTooltip from "./LoyaltyPointsHistory";
import { useLoyaltyPoints } from "./useLoyaltyPoints";

interface Props {
  role: UserRole | null;
}

const LoyaltyPointsBanner = ({ role }: Props) => {
  const isCustomer = role === "CUSTOMER";
  const { loyaltyPoints } = useLoyaltyPoints(isCustomer);

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 5,
        borderRadius: 1,
        overflow: "hidden",
        background: "linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)",
        color: "#fff",
        position: "relative",
      }}
    >
      <EmojiEventsIcon
        sx={{
          position: "absolute",
          right: -30,
          top: -30,
          fontSize: 250,
          opacity: 0.1,
          transform: "rotate(15deg)",
        }}
      />
      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "center" }}>
        <Box sx={{ p: { xs: 4, md: 5 }, flexGrow: 1 }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontWeight: "bold",
            }}
          >
            Wymieniaj zebrane punkty na wycieczki!
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, mb: 3, maxWidth: 600 }}>
            Z każdym zrealizowanym zamówieniem w naszym serwisie B2B rośnie Twoje saldo punktów. Gdy uzbierasz ich
            odpowiednią ilość, możesz odebrać jedną z poniższych darmowych nagród dla siebie lub swoich pracowników.
          </Typography>
        </Box>

        <Box sx={{ p: { xs: 4, md: 5 }, pt: { xs: 0, md: 5 }, minWidth: { md: 300 } }}>
          <LoyaltyPointsHistoryTooltip isCustomer={isCustomer}>
            <Box
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.15)",
                borderRadius: 3,
                p: 3,
                textAlign: "center",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  textTransform: "uppercase",
                  opacity: 0.9,
                  mb: 0.5,
                }}
              >
                Twoje saldo
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "bold",
                }}
              >
                {loyaltyPoints?.points ?? 0}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                punktów
              </Typography>
            </Box>
          </LoyaltyPointsHistoryTooltip>
        </Box>
      </Box>
    </Paper>
  );
};

export default LoyaltyPointsBanner;
